import { IADatabaseDocument } from "@/src/types/admissionDatabase";

const isAuthDoc = (value: unknown): value is IADatabaseDocument =>
  typeof value === "object" && value !== null && ("pdf_path" in value || "document_seria" in value || "full_name" in value);

const parseJsonString = (value: string): unknown => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    return JSON.parse(trimmed) as unknown;
  } catch {
    return null;
  }
};

const collectDocs = (value: unknown, bucket: IADatabaseDocument[]): void => {
  if (value == null) return;

  if (typeof value === "string") {
    collectDocs(parseJsonString(value), bucket);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectDocs(item, bucket));
    return;
  }

  if (typeof value !== "object") return;

  if (isAuthDoc(value)) {
    bucket.push(value);
    return;
  }

  Object.values(value).forEach((item) => collectDocs(item, bucket));
};

/** Normalizes GET /auth response into a flat documents array. */
export const parseAuthDocsResponse = (payload: unknown): IADatabaseDocument[] => {
  const docs: IADatabaseDocument[] = [];
  collectDocs(payload, docs);
  return docs;
};
